/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowLanguageExchangeTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowLanguageExchange,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Learn Together!",
    "Language Exchange Awaits!",
    "Speak and Share!",
  ],
  title: "Language Exchange",
  description: "Organize a fun language exchange event.",
  longDescription:
    "Gather your friends for a language exchange! Choose a date, decide on languages to practice, and plan activities for learning!",
  emoji: "🌍",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Language Exchange",
          emoji: "🌍",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the language exchange?",
          emoji: "📅",
          completeAction: {
            question: "Decide on languages to practice?",
            description: "What languages should we include in our exchange?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What languages should we consider?",
                emoji: "🗣",
                completeAction: {
                  question: "Decide on activities for practice?",
                  description:
                    "What activities should we plan for language practice?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What activities should we include?",
                      emoji: "🎉",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Learn Together!",
    outroDescription: "Your language exchange plans are set! Enjoy learning!",
  },
};
